// Forgot/Reset Password
export const RESET_PASSWORD_RECEIVE = "RESET_PASSWORD_RECEIVE";
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const EMAIL_SIGNUP_RECEIVE = "EMAIL_SIGNUP_RECEIVE";
export const EMAIL_SIGNUP_REQUEST = "EMAIL_SIGNUP_REQUEST";
export const EMAIL_SIGNUP_FAILURE = "EMAIL_SIGNUP_FAILURE";

export const HATCH_FOR_WORK_SIGNUP_RECEIVE = "HATCH_FOR_WORK_SIGNUP_RECEIVE";
export const HATCH_FOR_WORK_SIGNUP_REQUEST = "HATCH_FOR_WORK_SIGNUP_REQUEST";
export const HATCH_FOR_WORK_SIGNUP_FAILURE = "HATCH_FOR_WORK_SIGNUP_FAILURE";

const User = {
  RESET_PASSWORD_RECEIVE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_FAILURE,
  EMAIL_SIGNUP_RECEIVE,
  EMAIL_SIGNUP_REQUEST,
  EMAIL_SIGNUP_FAILURE,
  HATCH_FOR_WORK_SIGNUP_RECEIVE,
  HATCH_FOR_WORK_SIGNUP_REQUEST,
  HATCH_FOR_WORK_SIGNUP_FAILURE,
};

export default User;
